import DefaultDiamond from "@/components/DefaultDiamond";
import DiamondStock from "@/components/DiamondStock";
import Diamond from "@/components/Diamond";
import NotFound from "@/components/NotFound";
import store from "@/store";
import LabGrown from "@/components/LabGrown.vue";

const routesDE = [
	{
		path: "/diamanten/kaufen/",
		name: "default-diamond",
		props:  {
			sSearch: store.getters["setSearchData/getDefaultStockSearch"]
		},
		component: DefaultDiamond
	},
	{
		path: "/diamanten/suchen/",
		name: "diamond-stock",
		props:  {
			showMenu: true,
			sType: 1,
			stockSearch: store.getters["setSearchData/getDiamondStockSearch"]
		},
		component: DiamondStock
	},
	{
		path: "/diamanten/lab-grown/suchen/",
		name: "lab-grown",
		props:  {
			labSearch: store.getters["setSearchData/getLabGrownSearch"]
		},
		component: LabGrown
	},
	{
		path: "/diamanten/kaufen/:diamondId(\\d+)/",
		name: "diamond-data",
		props: true,
		component: Diamond,
	},
	{
		path: '/404/',
		name: '404',
		component: NotFound
	},
	{
		path: '/:pathMatch(.*)*/',
		name: 'not-found',
		component: NotFound
	}
];
export default routesDE;